import { FunctionComponent, memo } from 'react';
import { StoryCardType } from '../../../services';
import { HorizontalStoryFeedCardProps } from '../../../shared';
import { HorizontalStoryFeedArticle } from './HorizontalStoryFeedArticle';
import { HorizontalStoryFeedEditorial } from './HorizontalStoryFeedEditorial';
import { HorizontalStoryFeedEvent } from './HorizontalStoryFeedEvent';
import { HorizontalStoryFeedMedia } from './HorizontalStoryFeedMedia';
import { HorizontalStoryFeedPoll } from './HorizontalStoryFeedPoll';
import { HorizontalStoryFeedPost } from './HorizontalStoryFeedPost';
import { HorizontalStoryFeedSocial } from './HorizontalStoryFeedSocial';
import { HorizontalStoryFeedThread } from './HorizontalStoryFeedThread';

export const HorizontalStoryFeedCard: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    switch (card.type) {
      case StoryCardType.IMAGE:
      case StoryCardType.AUDIO:
      case StoryCardType.VIDEO:
      case StoryCardType.PDF:
        return <HorizontalStoryFeedMedia card={card} />;
      case StoryCardType.THREAD:
        return <HorizontalStoryFeedThread card={card} />;
      case StoryCardType.EDITORIAL:
        return <HorizontalStoryFeedEditorial card={card} />;
      case StoryCardType.EVENT:
        return <HorizontalStoryFeedEvent card={card} />;
      case StoryCardType.QUOTE:
        return <HorizontalStoryFeedSocial card={card} />;
      case StoryCardType.ARTICLE:
        return <HorizontalStoryFeedArticle card={card} />;
      case StoryCardType.POST:
        return <HorizontalStoryFeedPost card={card} />;
      case StoryCardType.POLL:
        return <HorizontalStoryFeedPoll card={card} />;
      default:
        return null;
    }
  }
);
